/* ============================================================
   MAISON PETÌT — global.js
   Shared behavior: scroll reveal, body lock, drawer bus,
   header scroll state, accordions, qty steppers.
   Section-specific JS lives in each section's {% javascript %}.
   ============================================================ */
(function () {
  'use strict';

  /* ---- Scroll reveal -------------------------------------------- */
  var reveals = document.querySelectorAll('[data-reveal]');
  if (reveals.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---- Body scroll lock ----------------------------------------- */
  var locks = 0;
  window.MP = window.MP || {};
  window.MP.lock = function () { locks++; document.body.classList.add('is-locked'); };
  window.MP.unlock = function () { locks = Math.max(0, locks - 1); if (!locks) document.body.classList.remove('is-locked'); };

  /* ---- Tiny event bus (cart drawer <-> header, etc.) ------------ */
  var bus = document.createElement('div');
  window.MP.on = function (n, fn) { bus.addEventListener(n, fn); };
  window.MP.emit = function (n, d) { bus.dispatchEvent(new CustomEvent(n, { detail: d })); };

  /* ---- Header scroll state -------------------------------------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var last = 0, ticking = false;
    var onScroll = function () {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 40);
      if (y > last && y > 300) header.classList.add('is-hidden');
      else header.classList.remove('is-hidden');
      last = y; ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(onScroll); ticking = true; }
    }, { passive: true });
  }

  /* ---- Accordions (details-style, used on PDP & policies) ------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-accordion-trigger]');
    if (!trigger) return;
    var item = trigger.closest('[data-accordion]');
    if (!item) return;
    var open = item.classList.toggle('is-open');
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---- Quantity steppers ---------------------------------------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var wrap = step.closest('[data-qty]');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v += parseInt(step.getAttribute('data-qty-step'), 10);
    input.value = Math.max(parseInt(input.min || '1', 10), v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---- Esc closes any open overlay ------------------------------ */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') window.MP.emit('overlay:close');
  });
})();
